module.exports = __webpack_public_path__ + "static/img/front-hash.08317f97.png";